import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "@services/api.service";
import { SessionService } from "@services/session.service";
import { environment } from "@env/environment";

@Injectable({
    providedIn: "root",
})
export class ExtenderSesionService {
    private readonly minutosProlongacion = 10;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService
    ) {}

    extenderSesion<T = any>(minutos: number = this.minutosProlongacion): Observable<T> {
        const url = `${environment.backendUrl}/${environment.extenderSesion}`;
        const idSesion = this.sessionService.getSesionActual()?.id_sesion ?? "";

        return this.apiService.privatePostObservable<T>(url, { idSesion, minutos });
    }
}
